export default "<ngx-spinner></ngx-spinner>\r\n<router-outlet></router-outlet>\r\n"